import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { GetHistoryAsyncStatusListDTO } from '@/services/history/service/history.repository.interface.ts';
import { GetHistoryAsyncStatusList } from '@/infrastructure/api-functions/interface/get-history-async-status-list.interface';
import type { AsyncStatusItem } from '@/services/history/type/history.type';

@injectable()
export class GetHistoryAsyncStatusListDTOImpl implements GetHistoryAsyncStatusListDTO {
    constructor(
        @inject(GetHistoryAsyncStatusList)
        private readonly _getHistoryAsyncStatusListApi: GetHistoryAsyncStatusList,
    ) { }

    async fetch(taskIds: string[]): Promise<AsyncStatusItem> {
        const taskIdsStr = taskIds.join(',');
        const res = await this._getHistoryAsyncStatusListApi.getHistoryAsyncStatusList({ task_ids: taskIdsStr });

        return res.map(item => {
            return {
                taskId: item.task_id,
                title: item.title,
                isRead: item.is_read,
                updatedAt: item.updated_at,
                taskType: item.task_type,
                asyncStatus: item.async_status,
                type: item.type,
            };
        });
    }
}
